// ----------------------------------------------------------------------
// <copyright file="Izenda.UserAccountDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';
import LoadingManager from 'modules/Izenda.LoadingManager';
import { isNil } from 'lodash/fp';
const ROOT_URL = 'report/';

const fetchers = {
  /**
   * Load report
   * @param  {string} tenantId
   * @returns {Promise}
   */
  getReports(tenantId) {
    const url = `${ROOT_URL}reportsByTenant/`;
    return fetch(isNil(tenantId) ? url : url + tenantId).get();
  },

  /**
   * Validate embedded report
   * @param  {string} tenantId
   * @param  {string} reportId
   * @param  {string} reportName
   * @param  {string} reportPartName
   * @returns {Promise}
   */
  validateEmbeddedReport(tenantId, reportId, reportName, reportPartName) {
    let url = `${ROOT_URL}validateEmbeddedReport/`;
    !isNil(tenantId) && (url += tenantId);
    url = `${url}?reportId=${reportId}&reportName=${encodeURIComponent(reportName)}&reportPartName=${encodeURIComponent(
      reportPartName
    )}`;
    return fetch(url).get();
  }
};

LoadingManager.linkToLoadingProgress(fetchers);

export default fetchers;



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.EmbedReportDataFetcher.js